import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CompareBase icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CompareBase } from '@sravni/design-system-icons'
 *
 * <CompareBase />
 * ```
 */
var CompareBase = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CompareBase", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "14.5", y: "11.25", width: "5.5", height: "1.5", rx: ".75", transform: "rotate(90 14.5 11.25)", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "11", width: "6.5", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "11", y: "13", width: "5.5", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "15", width: "6.5", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "3", width: "14", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "7", width: "14", height: "1.5", rx: ".75", fill: "currentColor" }))); });

export { CompareBase };
//# sourceMappingURL=CompareBase.js.map
